// Task T-5: interactive Practice section data — 3 lessons as proof of concept.
// Keeps drag-drop simple + mobile-friendly. Uses HTML5 drag events (no extra libs).
// Falls back to tap-to-select on mobile via the same state machine.
//
// Each item is `{ id, label, group }`. Groups are the drop zones.
// Answers are considered correct when every item sits in the group whose key
// matches the item's `group` field.

export const PRACTICE_LESSONS = {
  // Fractions — sort visual fractions into equivalent buckets
  "math-02-introduction-to-fractions": {
    prompt: "Drag each fraction into its correct bucket:",
    groups: [
      { key: "half",  label: "= 1/2" },
      { key: "third", label: "= 1/3" },
      { key: "quarter", label: "= 1/4" },
    ],
    items: [
      { id: "f1", label: "2/4", group: "half" },
      { id: "f2", label: "3/6", group: "half" },
      { id: "f3", label: "2/6", group: "third" },
      { id: "f4", label: "3/9", group: "third" },
      { id: "f5", label: "2/8", group: "quarter" },
      { id: "f6", label: "3/12", group: "quarter" },
    ],
    feedback_ok: "Great! You spotted every equivalent fraction.",
    feedback_partial: "Close — check the ones still in the tray.",
  },

  // Nouns / Verbs / Adjectives
  "english-03-nouns-verbs-adjectives": {
    prompt: "Drag each word into its part-of-speech bucket:",
    groups: [
      { key: "noun", label: "Noun" },
      { key: "verb", label: "Verb" },
      { key: "adjective", label: "Adjective" },
    ],
    items: [
      { id: "w1", label: "school", group: "noun" },
      { id: "w2", label: "brave",  group: "adjective" },
      { id: "w3", label: "run",    group: "verb" },
      { id: "w4", label: "amma",   group: "noun" },
      { id: "w5", label: "sunny",  group: "adjective" },
      { id: "w6", label: "read",   group: "verb" },
    ],
    feedback_ok: "Nailed it — every word in the right column!",
    feedback_partial: "Almost — one or two still need a home.",
  },

  // Living vs Non-living
  "science-02-living-and-non-living": {
    prompt: "Drag each thing to the correct bucket:",
    groups: [
      { key: "living",     label: "Living" },
      { key: "non_living", label: "Non-living" },
    ],
    items: [
      { id: "t1", label: "🌳 tree",   group: "living" },
      { id: "t2", label: "🐟 fish",   group: "living" },
      { id: "t3", label: "🚗 car",    group: "non_living" },
      { id: "t4", label: "🪨 rock",   group: "non_living" },
      { id: "t5", label: "🌱 sapling", group: "living" },
      { id: "t6", label: "💧 water",  group: "non_living" },
    ],
    feedback_ok: "You sorted every one correctly!",
    feedback_partial: "Nearly there — recheck the tray.",
  },
};
